import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Number extends OBase {
  update () {
    let valTree = this.getObjectInput('Number');
    let pOutput = this.getGenericObjectOutput('Number');

    // var outTree = new Geometry.DataTree();

    // for (let i = 0; i < valTree.branches.length; i++) {
    //   for (let j = 0; j < valTree.branches[i].length; j++) {
    //     let val = valTree.branches[i][j];
    //     outTree.add(val, valTree.paths[i]);
    //   }
    // }

    pOutput.value = valTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Number.js